// Ouvre la modale de connexion globale (rendue par PageLayout).
export const openLoginModal = () => {
  try {
    window.dispatchEvent(new Event("anyhomes:open-login"));
  } catch {
    /* ignore */
  }
};
